import { render, staticRenderFns } from "./HeaderButtons.vue?vue&type=template&id=7c873b6e&"
import script from "./HeaderButtons.vue?vue&type=script&setup=true&lang=js&"
export * from "./HeaderButtons.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports